import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupLandingPageComponent } from './group-landing-page.component';

const routes: Routes = [
  { path: '', component: GroupLandingPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupLandingPageRoutingModule { }
